import { cloneDeep } from 'lodash';

import types from './types';

const initialState = {};

function apiCallReducer(state = initialState, action) {
	switch (action.type) {
		case types.SET_API_CALL_PENDING: {
			return {
				...state,
				[action.apiCall]: {
					...state[action.apiCall],
					error: action.errorStatus,
					pending: action.payload
				}
			};
		}
		case types.SET_API_CALL_ERROR:
			return {
				...state,
				[action.apiCall]: {
					...state[action.apiCall],
					error: action.payload,
					pending: false
				}
			};
		case types.RESET_ALL_ERRORS: {
			const store = cloneDeep({ ...state });

			for (let index = 0; index < Object.keys(store).length; index += 1) {
				const apiCall = Object.keys(store)[index];

				if (typeof store[apiCall] !== 'undefined' && store[apiCall].error !== false) {
					store[apiCall].error = false;
				}
			}

			return {
				...store
			};
		}

		default:
			return state;
	}
}

export default apiCallReducer;
